import { Select, useSelectItemContext } from "@ark-ui/react";
import type { ComponentProps } from "react";

type RenderSelectedCallback = (props: { selected: boolean }) => React.ReactNode;
type ItemProps = ComponentProps<typeof Select.Item>;
type CustomProps = {
  children?: React.ReactNode | RenderSelectedCallback;
};
type Props = Omit<ItemProps, keyof CustomProps> & CustomProps;

const Item = ({ children, ...rest }: Props) => {
  return (
    <Select.Item {...rest}>
      {typeof children === "function" ? <SelectedItemRenderer renderer={children} /> : children}
    </Select.Item>
  );
};

export default Item;

const SelectedItemRenderer = ({ renderer }: { renderer: RenderSelectedCallback }) => {
  const { selected } = useSelectItemContext();

  return renderer({ selected });
};
